<div *ngIf="!storeService.getConditionalBalance()">
  @let cnt = productService.getWarehouseInfo(column.key, product);

  @if (cnt > 0) {
    {{ productService.getWarehouseInfo(column.key, product).toLocaleString() }} <span class="unit"> {{ unitHeader }}</span>
  } @else {
    -
  }
</div>

<div *ngIf="storeService.getConditionalBalance()" class="table-basket-num" [ngClass]="productService.getAvailability(column.key, product)">
  <span></span>
</div>

<div *ngIf="product.supplyTerm > 0 && column.title === translations.supplier">
  <small i18n="@@DaysShort" nbTooltip="Срок доставки">{{ product.supplyTerm }} д.</small>
</div>
